import * as n from "react";
import { TU_SKIN as i, MOVISTAR_SKIN as m, O2_NEW_SKIN as a, O2_SKIN as c, VIVO_NEW_SKIN as s, VIVO_SKIN as S, TELEFONICA_SKIN as u, BLAU_SKIN as p } from "./constants.js";
import { getBlauSkin as N } from "./blau.js";
import { getTelefonicaSkin as f } from "./telefonica.js";
import { getVivoSkin as I } from "./vivo.js";
import { getVivoNewSkin as k } from "./vivo-new.js";
import { getO2Skin as g } from "./o2.js";
import { getO2NewSkin as _ } from "./o2-new.js";
import { getMovistarSkin as K } from "./movistar.js";
import { getTuSkin as O } from "./tu.js";
const B = (r, o)=>{
    switch(r){
        case p:
            return N();
        case u:
            return f();
        case S:
            return I();
        case s:
            return k();
        case c:
            return g();
        case a:
            return _();
        case m:
            return K();
        case i:
            return O();
        default:
            throw Error("Unknown skin name: " + r);
    }
}, V = (r)=>n.Children.toArray(r).reduce((t, e)=>e.type === n.Fragment ? t.concat(V(e.props.children)) : (t.push(e), t), []);
export { V as flattenChildren, B as getSkinByName };
